import styled from '@emotion/styled';
import { Button, Typography, useMediaQuery } from '@mui/material';
import { useLocationFilterModalAtom } from '../hooks/use-location-filter-modal';
import useSetLocality from '../hooks/use-set-locality';

interface LocationCardProps {
  locality: string;
  administrativeLevel1: string;
  imgSrc: string;
}

const StyledButton = styled(Button)`
  width: 225px;
  height: 263px;
  border-radius: 13.43px;
  background: linear-gradient(174deg, #fff3dc 0%, #ffcf31 85.97%);
  text-transform: none;
  display: flex;
  flex-direction: column;
  text-align: 'center';
  justify-content: flex-start;
  padding-top: 20px;
  & .MuiButton-label {
    flex-direction: column;
  }
  &:hover {
    background-image: linear-gradient(180deg, #ffcf31 0%, rgba(255, 243, 221, 0) 90.1%);
  }
`;
const StyledBigText = styled(Typography)`
  color: #000;
  text-align: center;
  font-family: var(--font-work-sans), sans-serif;
  font-size: 20;
  font-style: normal;
  font-weight: 600;
  line-height: 157.3%; /* 37.247px */
`;

const StyledSmallText = styled(Typography)`
  color: #251628;
  text-align: center;
  font-family: var(--font-work-sans), sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 157.3%; /* 25.168px */
`;

export function LocationCard({ locality, administrativeLevel1, imgSrc }: LocationCardProps) {
  const setLocality = useSetLocality();
  const { setLocationFilterModal } = useLocationFilterModalAtom();
  const isMobile = useMediaQuery('(max-width:768px)');

  const DynamicButton = styled(StyledButton)`
    background-image: url(${imgSrc});
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    margin-left: ${isMobile ? '20px' : '0px'};
    &:hover {
      background-image: linear-gradient(180deg, #ffcf31 0%, rgba(255, 243, 221, 0) 90.1%),
        url(${imgSrc});
    }
  `;
  return (
    <DynamicButton
      onClick={() => {
        setLocality(locality);
        setLocationFilterModal(false);
      }}
    >
      <StyledBigText>{`${locality}, ${administrativeLevel1}`}</StyledBigText>
    </DynamicButton>
  );
}
export function AllLocationCard({ numExp }: { numExp: number }) {
  const setLocality = useSetLocality();
  const { setLocationFilterModal } = useLocationFilterModalAtom();
  const isMobile = useMediaQuery('(max-width:768px)');

  return (
    <StyledButton
      onClick={() => {
        setLocality('');
        setLocationFilterModal(false);
      }}
      style={{ justifyContent: 'center', marginLeft: isMobile ? '20px' : '0px' }}
    >
      <StyledBigText>See experiences in all locations</StyledBigText>
      <StyledSmallText
        style={{
          borderRadius: '32px',
          border: ' 1px solid #FFE590',
          background: '#FFF3DC',
          paddingLeft: '5px',
          paddingRight: '5px',
        }}
      >
        {numExp} experiences
      </StyledSmallText>
    </StyledButton>
  );
}
